<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card(min-height="80vh")
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic100}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic800--text Pick list
            v-col.shrink
              v-btn(color="info500" dark @click="clickDownloadFile()" depressed height=32)
                .button-AA-small.basic100--text {{ $t('download') }}
        v-divider.basic300
        v-card-text.pa-0(style="padding-bottom:90px")
          v-layout.my-12(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          div(v-else)
            .header.px-4.py-2.d-flex
              .p2.basic600--text Generated: {{ new Date().toISOString() | convertServerDateWithZone(timezone) }}
              v-spacer
              .p2.basic600--text Orders: {{ orderCount }}

            div(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`")
              v-row(no-gutters)
                v-col.shrink.py-2
                  div(style="width: 80px")
                    div.c2.basic600--text.pl-4 #
                v-col.py-2
                  div.d-flex.align-center
                    div.c2.basic600--text {{ $t('product_variant') }}
                    v-spacer
                    div.d-flex.align-center(style="width: 100px;")
                      div.c2.basic600--text {{ $t('qty') }}
                      v-spacer
                      div.d-flex.align-center.pr-2(@click="showRid = !showRid")
                        div.c2.basic600--text {{ $t('order_id') }}
                        v-icon(v-if="!showRid" small color="basic600") mdi-chevron-down
                        v-icon(v-if="showRid" small color="basic600") mdi-chevron-up

            template(v-for="(pick, idx) in pickList")
              v-row(no-gutters :key="pick+idx")
                v-col.shrink.py-3
                  div.d-flex.align-center.justify-center(style="width: 80px")
                    div.p2.basic600--text {{ idx+1 }}
                    div.ml-3
                      v-img(:src="pick.image ? `https://img.yezza.io/100x100/${pick.image.path}` : require('@/assets/image_placeholder.png')" max-width="40px" width="40px" height="40px")
                v-col.py-3
                  div.d-flex.align-center.py-2
                    div
                      div.s2.primary--text {{ pick.name }}
                      template(v-for="addon in pick.add_ons")
                        div.c1.basic600--text(:key="addon.id") + {{ addon.name }}{{ addon.total_quantity > 1 ? ' x ' + addon.total_quantity : '' }}
                    v-spacer
                    div.d-flex.align-center(v-if="pick.variants.length === 0" style="width: 100px;")
                      div(style="width: 20px;")
                        div.p2.basic600--text.text-center {{ pick.total_quantity }}
                      v-spacer
                      div(v-if="showRid")
                        template(v-for="rid in pick.lead_rids")
                          div.p2.basic600--text.pr-4.my-1 {{ '#' + rid }}
                      div.p2.basic600--text.pr-4(v-else) -
                  template(v-for="product in pick.variants")
                    v-divider.basic300
                    div.d-flex.align-center
                      div.c1.basic700--text.my-2 {{ product.type === 'variant' ? 'Variant:' : product.type === 'addon' ? 'Add-ons:' : '' }} {{ product.name }}
                      v-spacer
                      div.d-flex.align-center(style="width: 100px;")
                        div(style="width: 20px;")
                          div.p2.basic600--text.text-center {{ product.total_quantity }}
                        v-spacer
                        div(v-if="showRid")
                          template(v-for="rid in product.lead_rids")
                            div.p2.basic600--text.pr-4.my-1 {{ '#' + rid }}
                        div.p2.basic600--text.pr-4(v-else) -
              v-divider.basic400(v-if="idx+1 !== pickList.length")

</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'PickListDialog',
  props: ['open', 'leads'],
  data: () => ({
    isFetching: false,
    pickList: [],
    showRid: false,
    orderCount: 0,
    timezone: 'Asia/Kuala_Lumpur'
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.fetchPickList()
    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  },
  methods:{
    fetchPickList() {
      this.isFetching = true
      this.orderCount = this.leads.length
      const leadIds = this.leads.map(m => m.pid).join()
      let url = `/leads/pick_list?company=${this.company.id}&lead_ids=${leadIds}`
      this.$axios.get(url)
        .then((response) => {
          this.pickList = response.data
          this.isFetching = false
        })
        .catch(() => {})
    },
    clickDownloadFile () {
      const leadIds = this.leads.map(m => m.id).join()
      let exportUrl = `/leads/pick_list_export_csv/?company=${this.company.id}&lead_ids=${leadIds}`
      let exportDomain = 'https://export-test.yezza.io'
      if (process.env.VUE_APP_ENV === 'prod') {
        exportDomain = 'https://export.yezza.io'
      }
      this.$axios.post(`/users/${this.user.id}/request_otk/`)
        .then(response => {
          exportUrl = exportDomain + exportUrl
          exportUrl += `&key=${response.data.key}`
          if (this.$isMobile) {
            window.open(exportUrl)
          } else {
            location.href = exportUrl
          }
        }).catch(() => {})
    },
  },
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "product_variant": "Product/variant"
  },
  "id": {
    "product_variant": "Produk/varian"
  }
}
</i18n>
